export default function BrowserDetection() {

    let userAgent = navigator.userAgent;
    let browserName;

    // console.log("userAgent", userAgent)
    // // Opera 8.0+
    // const isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;

    // // Firefox 1.0+
    // const isFirefox = typeof InstallTrigger !== 'undefined';

    // // Safari 3.0+ "[object HTMLElementConstructor]" 
    // const isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));

    // // Internet Explorer 6-11
    // const isIE = /*@cc_on!@*/false || !!document.documentMode;

    // // Edge 20+
    // const isEdge = !isIE && !!window.StyleMedia;

    // // Chrome 1 - 79
    // const isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);

    // // Edge (based on chromium) detection
    // const isEdgeChromium = isChrome && (navigator.userAgent.indexOf("Edg") != -1);

    // // Blink engine detection
    // const isBlink = (isChrome || isOpera) && !!window.CSS;

    // // if (userAgent.match(/chrome|chromium|crios/i)) {
    // //     return "chrome";
    // // } else if (userAgent.match(/firefox|fxios/i)) {
    // //     return "firefox";
    // // } else if (userAgent.match(/safari/i)) {
    // //     return "safari";
    // // } else if (userAgent.match(/opr\//i)) {
    // //     return "opera";
    // // } else if (userAgent.match(/edg/i)) {
    // //     return "edge";
    // // } else {
    // //     return "No browser detection";
    // // }
    // if (userAgent.indexOf("Edge") > -1) {
    //     return "edge";

    // }
    // else if (userAgent.indexOf("Edg") > -1) {
    //     return "chromium-based-edge";
    // }
    // // Opera 8.0+
    // else if ((!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0) {
    //     return 'opera'
    // }
    // // Firefox 1.0+
    // else if (isFirefox) {
    //     return 'firefox'
    // }

    // // Safari 3.0+ "[object HTMLElementConstructor]" 
    // else if (isSafari) {
    //     return 'safari'
    // }

    // // Internet Explorer 6-11
    // else if (isIE) {
    //     return "IE"
    // }

    // // Edge 20+
    // else if (!isIE && !!window.StyleMedia) {
    //     // console.log("isEdge", isEdge)
    //     return 'edge'
    // }

    // // Chrome 1 - 71
    // else if (isChrome) {
    //     return 'chrome'
    // }
    // else if (isEdgeChromium) {
    //     return 'edgeChromium'
    // }

    // // Blink engine detection
    // else if (isBlink) {
    //     return 'blink'
    // }
    // else {
    //     return 'notDetected'
    // }

    // //  document.querySelector("h1").innerText="You are using "+ browserName +" browser";     
    if ((!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0) {
        return 'Opera';
    }
    else if (userAgent.match(/edg/i)) {
        return 'chromium-based-edge'
    }
    else if (navigator.userAgent.indexOf("Chrome") != -1) {
        return 'Chrome';

    }
    else if (navigator.userAgent.indexOf("Safari") != -1) {
        return 'Safari';
    } else if (navigator.userAgent.toLowerCase().indexOf("safari/") > -1 && navigator.userAgent.toLowerCase().indexOf("chrome") < 0) {
        return 'Safari';
    } else if (navigator.userAgent.indexOf("Firefox") != -1) {
        return 'Firefox';
    } else if ((navigator.userAgent.indexOf("MSIE") != -1) || (!!document.documentMode == true)) {
        return 'IE';//crap
    } else {
        return 'Unknown';
    }
}
